import {useMessages} from "i18n";

/**
 * FAQ content (ui#97, wave 2; localised in ui#101; relocated to /features in ui#110). ONE source of
 * truth: the visible FAQ section on the `/features` page ({@link ./FeaturesContent.tsx}) renders these
 * items AND the features route feeds the exact same array to {@link ../../seo/structuredData.ts}'s
 * `faqPageLd` so the FAQPage JSON-LD can never drift from the questions a visitor actually reads on
 * that same URL (Google requires FAQPage markup to match on-page FAQ content).
 *
 * The copy lives in the active locale catalog (`messages.home.faq`); {@link useFaqItems} reads it so
 * the section and the JSON-LD both follow the page's language. Every answer is factual and verifiable
 * against the product (caps from {@link ../gating.ts}, encryption model per the Privacy Policy).
 */

export interface FaqItem {
	/** The question, verbatim — used as the visible heading and the JSON-LD `Question.name`. */
	question: string;
	/** Plain-text answer — rendered as a paragraph and as the JSON-LD `Answer.text`. */
	answer: string;
}

/** The home FAQ, in display order, in the active locale. */
export function useFaqItems(): FaqItem[] {
	return useMessages().home.faq;
}
